export type KeysWithValueType<T, V> = { [K in keyof T]: T[K] extends V ? K : never }[keyof T];

export const numericComparator =
  <T, E extends KeysWithValueType<T, number>>(key: E) =>
  (t1: T, t2: T) =>
    (t1[key] as number) - (t2[key] as number);

export const compareBy =
  <T>(selector: (t: T) => number) =>
  (a: T, b: T) =>
    selector(a) - selector(b);

export const lexicographicalComparator = (a: string, b: string) => a.localeCompare(b);

export const range = (startInclusive: number, endExclusive: number) =>
  Array.from({ length: endExclusive - startInclusive }, (_, i) => i + startInclusive);

export const maxBy = <T>(elements: T[], comparisonTransform: (t: T) => number): T | undefined => {
  if (elements.length === 0) {
    return undefined;
  }

  let maxValue = comparisonTransform(elements[0]);
  let maxElement = elements[0];

  for (const element of elements) {
    const value = comparisonTransform(element);
    if (value > maxValue) {
      maxValue = value;
      maxElement = element;
    }
  }

  return maxElement;
};

export const minBy = <T>(elements: T[], comparisonTransform: (t: T) => number): T | undefined =>
  maxBy(elements, (element) => -comparisonTransform(element));
